import React, {Component} from 'react';
import AccountsIdentifiedForOptimization from "../components/tables/accumulatedOptimizationCategories";
import AccountsIdentifiedForOptimizationGraph from "../charts/accountsIdentifiedForOptimizationGraph"

import * as dataService from "../service/data-info-chart/requestsUtil"
import {OPTIMIZATION_MONITORING, ACCOUNTS_IDENTIFIED_FOR_OPTIMIZATION, WHITOUT_INFORMATION} from "../utils/constants";
import * as cbu from "../utils/checkBusinessUnit";

var Loader = require('react-loader');

class AccountsIdentifiedForOptimizationComponent extends Component {

  constructor(props) {
    super(props);
    this.state = {data: [], loaded: false}
  }

  componentDidMount() {
    dataService.getFetch(OPTIMIZATION_MONITORING + cbu.checkBusinessUnit(this.props.bu) + ACCOUNTS_IDENTIFIED_FOR_OPTIMIZATION)
      .then((json) => {
        this.setState({data: json, loaded: true})
      });
  }

  render() {
    if (this.state.data.length > 0) {
      return (
        <div>
          <AccountsIdentifiedForOptimization striped={true} data={this.state.data}/>
          <AccountsIdentifiedForOptimizationGraph data={this.state.data}/>
        </div>
      );
    } else {
      return (<h2 className="without-avilable-information">{WHITOUT_INFORMATION}</h2>);
    }


  }
}

export default AccountsIdentifiedForOptimizationComponent;




// WEBPACK FOOTER //
// ./src/components/accountsIdentifiedForOptimizationComponent.js